import { useEffect, useState } from 'react';

import type { InteractionMode } from '../../interactions-overlay/types.js';
import type { MenuDisplayMode } from '../ChartToolbarRenderer.js';

export const useToolbar = (
  collapsed: boolean,
  menuDisplayMode: MenuDisplayMode,
) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(!collapsed);
  const [lastItemSelected, setLastItemSelected] = useState<
    InteractionMode | undefined
  >(undefined);
  const [fitsBounds, setFitsBounds] = useState<boolean>(true);

  useEffect(() => {
    toggleExpanded(fitsBounds && !collapsed);
  }, [collapsed, fitsBounds]);

  const updateLastItemSelected = (lastItemSelected?: InteractionMode) => {
    setLastItemSelected(lastItemSelected);
  };

  const toggleExpanded = (state: boolean) => {
    setIsExpanded(state);
  };

  const updateFitsBounds = (isFitting: boolean) => setFitsBounds(isFitting);

  const isMenuShowable =
    menuDisplayMode === 'always' ||
    (menuDisplayMode === 'collapsed' && !isExpanded) ||
    (menuDisplayMode === 'expanded' && isExpanded);

  const shouldShowMenu = (!isMenuShowable && !fitsBounds) || isMenuShowable;

  const isCollapsable =
    menuDisplayMode !== 'expanded' && menuDisplayMode !== 'never';

  return {
    isExpanded,
    lastItemSelected,
    updateLastItemSelected,
    toggleExpanded,
    isCollapsable,
    fitsBounds,
    updateFitsBounds,
    shouldShowMenu,
  };
};
